import { DataTableColumn } from './DataTableColumn';

export function scaleWidths<T = any>(cols:DataTableColumn<T>[], pageWidth:number) {
  const totalWidth = cols.reduce((sum, c) => sum + (c.hidden ? 0 : c.width), 0);
  const scale = pageWidth / totalWidth;

  return cols.map(c => ({...c, width: Math.floor(c.width * scale)}));
}

